import { useEmployeeUpdateTabs } from '@/modules/Employee/components/Update/tabs'
import React from 'react'
import { Tabs } from 'vnetwork-ui'
import useTabs from '@/hooks/useTabs'
import Paper from '@/components/Paper'
import useAuthStore from '@/stores/useAuthStore'

const PersonalInfo: React.FC = () => {
    const { employee } = useAuthStore()
    const { TabProps, TabComponent } = useTabs({
        tabs: useEmployeeUpdateTabs({
            isSelf: true,
            employeeId: employee?.employee_id,
        }).filter((tab) => tab.value !== 'work-info'),
    })

    return (
        <div>
            <Tabs {...TabProps} className="mb-2 mt-0" />
            <Paper className="mt-2">{TabComponent}</Paper>
        </div>
    )
}

export default PersonalInfo
